import React from 'react';

import { Button, Container, Typography } from '@material-ui/core';

const WeHaveMoved = () => {
    return (
        <Container maxWidth="md">
            <div style={{
                alignItems: 'center', 
                display: 'flex',
                flexDirection: 'column',
                gap: '2rem',
                marginTop: '3rem'
            }}>
                <img src="/images/tic500.png" alt="logo" style={{
                    height: 'auto',
                    width: 'auto',
                    maxWidth: '200px',
                    maxHeight: '200px'
                }} />
                <Typography variant='h3' color='primary'>Important Update</Typography>
                <Typography variant='h6' color="textSecondary">The new contractual arrangements for engaging the services of an HMCTS Appointed Intermediary are now live. If you need an intermediary please use the link below.</Typography>
                <Button href="https://live-ticit2.web.app/public/enquiry" variant='contained' color='primary'>Click here to make a referral</Button>
            </div>

        </Container>
        // <div style={{ marginTop: '1rem' }}>
        //     <div style={{ display: 'flex', gap: '25px', justifyContent: 'center', padding: '1rem' }}>
        //         <img src="/images/tic500.png" alt="logo" style={{
        //             height: 'auto',
        //             width: 'auto',
        //             maxWidth: '200px',
        //             maxHeight: '200px'
        //         }} />
        //     </div>
        //     <div style={{ display: 'flex', gap: '25px', justifyContent: 'center', padding: '1rem' }}>
        //         <Typography variant='h3' color='primary'>Important Update</Typography>
        //     </div>
        //     <div style={{ display: 'flex', gap: '25px', justifyContent: 'center', padding: '1rem', maxWidth: '500px' }}>
        //         <Typography variant='h6'>The new contractual arrangements for engaging HMCTS Appointed Intermediary Services are now live. If you need an intermediary please use the link below</Typography>
        //     </div>
        // </div>
    );
};

export default WeHaveMoved;